import i18n from "@/i18n.js";
import RouterView from "@/components/RouterView";
import Home from "../views/Home.vue";
import AuthGuard from "@/router/auth-guard.js";

export default [
  {
    path: "/:lang",
    component: RouterView,
    beforeEnter(to, from, next) {
      const lang = to.params.lang;
      if (!["en", "np"].includes(lang)) return next("en");
      if (i18n.locale !== lang) {
        i18n.locale = lang;
      }
      return next();
    },
    children: [
      {
        path: "",
        name: "home",
        component: Home,
      },
      {
        path: "aboutMe",
        name: "aboutMe",
        component: () => import("@/views/AboutMe.vue"),
      },
      {
        path: "myWork/:type",
        name: "myWork",
        component: () => import("@/views/MyWork.vue")
      },
      {
        path: "work/:id",
        name: "workTopic",
        component: () => import("@/components/myWork/WorkTopic.vue")
      },
      {
        path: "downloads",
        name: "downloads",
        component: () => import("@/views/Downloads.vue")
      },
      {
        path: "download/:topic",
        name: "download",
        component: () => import("@/components/downloads/DownloadTopic.vue")
      },
      {
        path: "fileManager",
        name: "fileManager",
        component: () => import("@/views/FileManager.vue"),
        beforeEnter: AuthGuard,
      },
      {
        path: "disclaimer",
        name: "disclaimer",
        component: () => import("@/components/common/Disclaimer.vue")
      },
      {
        path: "privacyPolicy",
        name: "privacyPolicy",
        component: () => import("@/components/common/PrivacyPolicy.vue")
      },
      {
        path: "termsAndConditions",
        name: "termsAndConditions",
        component: () => import("@/components/common/TermsAndConditions.vue")
      }
    ],
  },
  {
    path: "*",
    redirect: `/${i18n.locale}/`,
  },
];
